import { setupColorModelSelect } from "./color-model-select"

function initServiceForm() {
  const colorSelect = document.querySelector(".service-color-select")
  const modelSelect = document.querySelector(".service-model-select")

  setupColorModelSelect({ colorSelect, modelSelect })
}

document.addEventListener("DOMContentLoaded", initServiceForm)
